// Statement Pieces ("Make A Statement") — compact rotating circle carousel.
// Scoped to one section id only. No @keyframes, no dependency on section
// custom_css (this section has none); plain setInterval opacity crossfade.
document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector(
    '[id$="__vitals_d9d73599_djGjeH"] .VtlsFeaturedCollectionGridContent__Products'
  );
  if (!container) return;
  var cards = container.querySelectorAll('.VtlsProductsGridProdCard');
  if (!cards.length) return;

  cards[0].classList.add('chd-scarousel-active');
  if (cards.length < 2) return;

  var i = 0;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  setInterval(function () {
    cards[i].classList.remove('chd-scarousel-active');
    i = (i + 1) % cards.length;
    cards[i].classList.add('chd-scarousel-active');
  }, reduceMotion ? 6000 : 4000);
});
